import { ImplementArchetypeViewModel } from "../ImplementArchetypeViewModel";
import { ImplementDimensionsSubform } from "portal/views/equipment/implements/ImplementDimensionsSubform";
import { ImplementManeuveringSubform } from "portal/views/equipment/implements/ImplementManeuveringSubform";
import { typedPath } from "typed-path";
import { useFormikContext } from "formik";
import React, { FC } from "react";

const S = typedPath<ImplementArchetypeViewModel>();
export const AutonomyMeasurementsStep: FC<{ disabled?: boolean }> = ({
  disabled,
}) => {
  const { values } = useFormikContext<ImplementArchetypeViewModel>();

  return (
    <>
      <ImplementDimensionsSubform
        basePath={S}
        mode={disabled ? "readonly" : "edit"}
      />
      <ImplementManeuveringSubform
        values={values}
        basePath={S}
        mode={disabled ? "readonly" : "edit"}
      />
    </>
  );
};
